import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Accounting } from '~/types/api.model';
import { ContactIntegrationsModel } from './ContactIntegrations';
export var ContactAccountantAccess = /*#__PURE__*/ function(ContactAccountantAccess) {
    /** Will appear when a contact isn't connected to a business. */ ContactAccountantAccess["NonCandidate"] = "nonCandidate";
    ContactAccountantAccess["Candidate"] = "candidate";
    ContactAccountantAccess["Invited"] = "invited";
    ContactAccountantAccess["Active"] = "active";
    return ContactAccountantAccess;
}({});
export var ContactEditMode = /*#__PURE__*/ function(ContactEditMode) {
    ContactEditMode["Editable"] = "editable";
    ContactEditMode["Readonly"] = "readonly";
    return ContactEditMode;
}({});
export var ContactStatus = /*#__PURE__*/ function(ContactStatus) {
    ContactStatus["Active"] = "active";
    ContactStatus["Archived"] = "archived";
    return ContactStatus;
}({});
export class ContactModel {
    static uniqueKey(param) {
        let { companyName, email } = param;
        return (companyName.trim() + email.trim()).toLowerCase();
    }
    static makeSample(param) {
        let { createdAt, vendorId = '' } = param;
        return new ContactModel({
            id: 'sample_contact_id',
            createdAt: createdAt.getTime(),
            userId: null,
            firstName: 'Sample',
            lastName: 'Client',
            companyName: 'Anchor (Sample)',
            email: 'sampleclient@sayanchor.com',
            phone: null,
            isSample: true,
            edit: {
                mode: "readonly"
            },
            vendorId,
            version: 'sample_contact_version',
            accountantAccess: "nonCandidate",
            status: "active",
            hasSignedAgreements: true,
            hasPendingProposals: false,
            integrations: [],
            editingLimitations: {
                isMultiVendorCustomer: false,
                hasVendorRelation: false
            }
        });
    }
    toJSON() {
        return this.dto;
    }
    toAssignedUser() {
        return {
            id: this.dto.id,
            firstName: this.dto.firstName,
            lastName: this.dto.lastName,
            email: this.dto.email,
            phone: this.dto.phone
        };
    }
    id() {
        return this.dto.id;
    }
    userId() {
        return this.dto.userId;
    }
    vendorId() {
        return this.dto.vendorId;
    }
    companyName() {
        return this.dto.companyName;
    }
    firstName() {
        return this.dto.firstName;
    }
    lastName() {
        return this.dto.lastName;
    }
    email() {
        return this.dto.email;
    }
    customerId() {
        return this.dto.customerId;
    }
    isSample() {
        return this.dto.isSample;
    }
    isEditable() {
        return this.dto.edit.mode === "editable";
    }
    isEmailEditable() {
        return this.dto.edit.mode === "editable" ? this.dto.edit.editable.isEmailEditable : false;
    }
    integratedId(param) {
        let { accounting } = param;
        const integrations = this.integrations();
        switch(accounting){
            case Accounting.QBO:
                return integrations.qboIntegratedId();
            case Accounting.Xero:
                return integrations.xeroIntegratedId();
        }
    }
    integrations() {
        return ContactIntegrationsModel.fromDTO(this.dto.integrations);
    }
    isIntegrated(param) {
        let { accounting } = param;
        return !!this.integratedId({
            accounting
        });
    }
    version() {
        return this.dto.version;
    }
    phone() {
        return this.dto.phone;
    }
    hasPendingProposals() {
        return this.dto.hasPendingProposals;
    }
    hasSignedAgreements() {
        return this.dto.hasSignedAgreements;
    }
    fullName() {
        return "".concat(this.dto.firstName, " ").concat(this.dto.lastName);
    }
    accountantAccess() {
        return this.dto.accountantAccess;
    }
    status() {
        return this.dto.status;
    }
    isActive() {
        return this.dto.status === "active";
    }
    uniqueKey() {
        return ContactModel.uniqueKey(this.dto);
    }
    isMultiVendorClient() {
        var _ref;
        var _this_dto_editingLimitations;
        return (_ref = (_this_dto_editingLimitations = this.dto.editingLimitations) === null || _this_dto_editingLimitations === void 0 ? void 0 : _this_dto_editingLimitations.isMultiVendorCustomer) !== null && _ref !== void 0 ? _ref : false;
    }
    hasServiceProviderBusiness() {
        var _ref;
        var _this_dto_editingLimitations;
        return (_ref = (_this_dto_editingLimitations = this.dto.editingLimitations) === null || _this_dto_editingLimitations === void 0 ? void 0 : _this_dto_editingLimitations.hasVendorRelation) !== null && _ref !== void 0 ? _ref : false;
    }
    update(changes) {
        return new ContactModel(_object_spread_props(_object_spread({}, this.dto, changes), {
            version: this.dto.version
        }));
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
export class NewContactModel {
    static make(newContact) {
        return new NewContactModel(newContact);
    }
    static makeEmpty() {
        return new NewContactModel({
            firstName: '',
            lastName: '',
            companyName: '',
            email: '',
            phone: ''
        });
    }
    toJSON() {
        return this.dto;
    }
    hasPartialContactDetails() {
        return hasPartialContactDetails(this.dto);
    }
    uniqueKey() {
        return ContactModel.uniqueKey(this.dto);
    }
    isSample() {
        return false;
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
function hasPartialContactDetails(param) {
    let { firstName, lastName, companyName, email, phone } = param;
    return !!(firstName || lastName || companyName || email || phone);
}
